define('ordersDetailOrderProductOptionEditOptionsView',[
  'module',
  'backbone',
  'underscore',
  'marionette',
  'ordersDetailOrderProductOptionEditOptionView'
], function (
  Module,
  Backbone,
  _,
  Marionette,
  OptionView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    childView: OptionView,
    className: 'orders-detail-order-options-edit-options-view'

   
  });
});
